import React from 'react';
import format from 'date-fns/format';

import { transformWithPrefix } from 'helpers/string';
import { dateToWords, exifDateToDate } from 'helpers/time';
import { uploadUrl } from 'helpers/api';

import styles from './styles.scss';
import cx from 'classnames';

export default class Photo extends React.PureComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      showFullDate: false,
    };
  }

  toggleDate = () => {
    this.setState({
      showFullDate: !this.state.showFullDate,
    });
  };

  render() {
    const {
      photo,
      backgroundImage,
      preview,
      className = '',
      imageClassName = '',
      childBirthday,
      transform,
      dateFormat,
      showUseCount = false,
    } = this.props;

    const { showFullDate } = this.state;
    const { DateTime } = photo.get('exif', {});
    const uploadUrl = photo.get('uploadUrl', null);
    const previewUrl = preview ? preview : photo.get('preview', null);

    const classes = cx(styles.photo, className, {
      [styles.backgroundImage]: backgroundImage,
    });

    // Use preview blob if available
    let src;
    if (previewUrl) {
      src = previewUrl;
    } else {
      src = uploadUrl;
    }

    let style = {};
    if (transform) {
      const { width, x, y } = transform;

      style = {
        width: `${width * 100}%`,
        left: '50%',
        top: '50%',
        [transformWithPrefix]:
          `translate(${(x - 0.5) * 100}%, ${(y - 0.5) * 100}%) ` + (transform.flip ? `scaleX(-1)` : ''),
      };
    }

    if (backgroundImage) {
      style.backgroundImage = `url('${src}')`;
    }

    let date = null;
    if (childBirthday && DateTime) {
      const label = dateFormat ? format(exifDateToDate(DateTime), dateFormat) : dateToWords(childBirthday, DateTime);

      date = (
        <div onClick={this.toggleDate} className={styles.date} title={!showFullDate ? DateTime : label}>
          {showFullDate ? DateTime : label}
        </div>
      );
    }

    const count = photo.get('useCount');
    const photoTitle =
      count > 1
        ? kroostApp.strings.usedPhotoMessagePlural.replace('{count}', count)
        : kroostApp.strings.usedPhotoMessageSingular;

    return (
      <div className={classes} style={style} onClick={this.props.callback}>
        {!backgroundImage ? <img className={imageClassName} src={src} /> : null}
        {date}
        {showUseCount && photo.get('useCount', 0) > 0 ? (
          <div className={styles.useCount} title={photoTitle}>
            {photo.get('useCount', 0) > 1 ? count : null}
          </div>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/photo/index.js